import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { I18n, LinkButton, Tooltip } from 'components';
import { scrollToBlock } from 'utils/scrollToBlock';
import { formatCurrency } from 'utils/formatString';
import { getDiscountTooltipText } from 'utils/summaryUtils';

import styles from '../../styles.pcss';

const cx = classNames.bind(styles);

const PaymentDetails = ({
  showConvergenceLink,
  details,
  yandexTariffContent,
  isPartnershipTariffConnected,
}) => {
  const totalPaymentText = useMemo(() => formatCurrency(details.tariffRcRateText), [details.tariffRcRateText]);

  const actualTooltipText = useMemo(() => {
    if (yandexTariffContent) {
      const { tooltipText, tooltipTextWithSubscription } = yandexTariffContent;

      return (
        <span dangerouslySetInnerHTML={{ __html: isPartnershipTariffConnected
          ? tooltipTextWithSubscription : tooltipText }}
        />
      );
    }
    return getDiscountTooltipText(details.discountParams);
  }, [yandexTariffContent, isPartnershipTariffConnected], details.discountParams);

  return (
    <tr className={cx('profileInfoRow')}>
      <td className={cx('profileInfoLabel')}>
        <I18n path="home.summary.tariffRateLabel" />
      </td>
      <td className={cx('profileInfoValue')}>
        <div className={cx('tariffRate')}>
          {showConvergenceLink ? (
            <>
              <LinkButton
                onClick={() => {
                  scrollToBlock('js-convergence-block');
                }}
              >
                {totalPaymentText}
              </LinkButton>
            </>
          ) : (
            <>{totalPaymentText}</>
          )}

          {details.tariffRcRateTooltip && (
            <Tooltip>
              {details.tariffRcRateTooltip}
            </Tooltip>
          )}
        </div>
        {(details.discountParams || details.tariffRcRateExtras?.length > 0) && (
          <div className={cx('summary-details')}>
            {details.tariffRcRateExtras?.length > 0 ? (
              <>
                {details.tariffRcRateExtras.map((item) => (
                  <div key={item.text}>
                    <span
                      className={cx('summary-details__text')}
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    />
                    {item.tooltip && (
                      <Tooltip>
                        {item.tooltip}
                      </Tooltip>
                    )}
                  </div>
                ))}
              </>
            ) : (
              <>
                <>
                  с учётом скидки
                  {' '}
                  {Number(details.discountParams.percent)}
                  %
                </>
                <Tooltip>
                  <div className={cx('summary-details__tooltip')}>
                    {actualTooltipText}
                  </div>
                </Tooltip>
              </>
            )}
          </div>
        )}
      </td>
    </tr>
  );
};

PaymentDetails.propTypes = {
  showConvergenceLink: PropTypes.bool,
  details: PropTypes.shape({
    tariffRcRateText: PropTypes.string,
    tariffRcRateTooltip: PropTypes.string,
    tariffRcRateExtras: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      tooltip: PropTypes.string,
    })),
    tariffRcRateExtraText: PropTypes.string,
    discountParams: PropTypes.shape({
      expDate: PropTypes.string,
      percent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      tooltip: PropTypes.string,
    }),
  }),
  yandexTariffContent: PropTypes.objectOf({
    tooltipTextWithSubscription: PropTypes.string,
    tooltipText: PropTypes.string,
  }),
  isPartnershipTariffConnected: PropTypes.bool,
};

export default PaymentDetails;
